import axios from 'lib/axios'
import React, { useState } from 'react'
import ToggleCheckbox from '../../components/checkbox'

export default function EnableAutoPricing({ organizationId, enabled, updateEnabled }) {
  const [updating, setUpdating] = useState(false)

  const changeValue = async (enabled) => {
    try {
      setUpdating(true)
      const url = `/super/organizations/${organizationId}/questionnaires/enable_auto_pricing`
      await axios.post(url, { is_auto_pricing_on: enabled ? 1 : 0 })
      updateEnabled(enabled)
    } catch (error) {
      console.error(error)
    } finally {
      setUpdating(false)
    }
  }

  return (
    <div className="questionnaire-admin-general-row">
      <ToggleCheckbox
        label="enable auto-pricing"
        defaultChecked={enabled}
        disabled={updating}
        onChange={(e) => changeValue(e.target.checked)}
      />
    </div>
  )
}
